"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _InputRaw = _interopRequireDefault(require("@commerce-ui/core2/InputRaw"));
var _QuantityPicker = require("../../QuantityPicker");
var _Select2Ui = _interopRequireDefault(require("../../Select2Ui"));
var _ButtonMinimalIcon = _interopRequireDefault(require("../../buttons/ButtonMinimalIcon"));
var _ItemRow = _interopRequireDefault(require("../../selectables/ItemRow"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconChevronDown = function IconChevronDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconChevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var QuantityPickerSmall = function QuantityPickerSmall(props) {
  var counter = props.controller || (0, _QuantityPicker.useQuantityPicker)(props);
  var ref = (0, _react.useRef)(null);
  var inputsDisplay = {
    select: counter.exceedsSelectRange ? {
      display: "none"
    } : {
      display: "flex"
    },
    input: counter.exceedsSelectRange ? {
      display: "block"
    } : {
      display: "none"
    }
  };
  return __jsx(_Box["default"], {
    sx: {
      height: 28,
      width: "100%",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "neutral",
      borderRadius: 14,
      ":focus-within": {
        borderColor: "main"
      }
    },
    "data-test": "quantity-picker-small",
    _ref: ref
  }, __jsx(_InputRaw["default"], (0, _extends2["default"])({}, counter.inputProps, {
    sx: _objectSpread(_objectSpread({}, inputsDisplay.input), {}, {
      width: 56,
      font: "body2",
      lineHeight: 1,
      minWidth: 50,
      height: 28,
      textAlign: "center",
      color: props.loading ? "beigeDarken" : "black"
    }),
    type: "number",
    noFocus: true,
    onKeyPress: function onKeyPress(event) {
      if ((event === null || event === void 0 ? void 0 : event.charCode) === 13) {
        event.target.blur();
      }
    }
  })), __jsx(_Select2Ui["default"], (0, _extends2["default"])({}, counter.selectProps, {
    button: function button(_ref) {
      var value = _ref.value;
      return __jsx(_ButtonMinimalIcon["default"], {
        sx: _objectSpread(_objectSpread({}, inputsDisplay.select), {}, {
          width: 56,
          font: "body2",
          lineHeight: 1,
          minWidth: 50,
          height: 28,
          color: props.loading ? "neutral" : "black"
        })
      }, __jsx(_Box["default"], {
        sx: {
          width: 56,
          alignItems: "center",
          justifyContent: "flex-end",
          position: "relative",
          textAlign: "right"
        }
      }, __jsx(_Box["default"], {
        sx: {
          width: "100%",
          height: "100%",
          position: "absolute",
          color: "black",
          textAlign: "center",
          pt: 5,
          left: -6
        }
      }, value), __jsx(IconChevronDown, null)));
    },
    selectable: __jsx(_ItemRow["default"], null),
    allowEmpty: false,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: ["70vw", null, 150],
    root: {
      height: ["70vh", null, 300],
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white"
    }
  })));
};
var _default = QuantityPickerSmall;
exports["default"] = _default;